import React from "react";
import { bool, string } from "prop-types";
import { classes } from "../utils/classes";

const AutocompleteDropdown = ({ display = false, className = "", ...props }) => {
	return (
		<div
			className={classes(
				"autocomplete__dropdown",
				display && "autocomplete__dropdown--show",
				className,
			)}
			{...props}
		/>
	);
};

AutocompleteDropdown.propTypes = {
	display: bool,
	className: string,
};

export default AutocompleteDropdown;
